import { render, staticRenderFns } from "./background-research.vue?vue&type=template&id=461401ec&"
import script from "./background-research.vue?vue&type=script&lang=js&"
export * from "./background-research.vue?vue&type=script&lang=js&"
import style0 from "./background-research.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports